export default (data, e) => {
  if (!!data && typeof data.callback === "function") {
    if (e) {
      data.callback(e);
    } else {
      data.callback();
    }
  }
}